module.exports = __webpack_public_path__ + "img/nav4.f6763e51.png";